import { PublicPage, H2, P, UL } from "@/components/PublicPage";
import { BUSINESS, waLink } from "@/lib/site";

export default function RefundPolicy() {
  return (
    <PublicPage testid="refund-page" overline="Kebijakan Pembatalan & Pengembalian" title="Kebijakan Pembatalan & Pengembalian">
      <P>Halaman ini menjelaskan ketentuan terkait pembatalan dan pengembalian untuk pembelian
        kredit di Mas Tofa AI. Kami berusaha menangani setiap kasus secara adil melalui peninjauan
        oleh dukungan (support).</P>

      <H2>Pesanan Belum Dibayar</H2>
      <P>Pesanan yang belum dibayar dapat diabaikan dan tidak menimbulkan kewajiban apa pun. Tidak
        ada kredit yang ditambahkan untuk pesanan yang belum diverifikasi.</P>

      <H2>Pembayaran Berhasil</H2>
      <P>Setelah pembayaran diverifikasi dan kredit ditambahkan, kredit tersebut siap digunakan.
        Permintaan terkait pembayaran yang telah berhasil akan ditinjau oleh dukungan.</P>

      <H2>Pembayaran Ganda / Duplikat</H2>
      <P>Jika terjadi pembayaran ganda untuk pesanan yang sama, silakan hubungi Admin dengan bukti
        transfer. Kasus akan ditinjau oleh dukungan.</P>

      <H2>Pembayaran Gagal</H2>
      <P>Jika pembayaran tidak berhasil atau ditolak saat verifikasi, tidak ada kredit yang
        ditambahkan.</P>

      <H2>Kegagalan Pembuatan Video</H2>
      <P>Jika pembuatan video gagal karena kendala sistem/penyedia, mekanisme kredit pada sistem
        akan menyesuaikan sesuai hasil proses. Untuk kasus yang perlu ditinjau lebih lanjut,
        silakan hubungi Admin.</P>

      <H2>Kredit yang Belum / Sudah Digunakan</H2>
      <UL items={[
        "Kredit yang belum digunakan dapat ditinjau oleh dukungan sesuai kasus.",
        "Kredit yang sudah digunakan untuk pembuatan video tidak dapat dikembalikan.",
      ]} />

      <H2>Transfer Manual BCA</H2>
      <P>Untuk pembayaran transfer manual, verifikasi dilakukan oleh Admin. Pastikan nominal
        transfer sesuai dan unggah bukti pembayaran yang jelas untuk mempercepat peninjauan.</P>

      <H2>Sengketa Pembayaran</H2>
      <P>Setiap sengketa pembayaran akan ditinjau oleh dukungan berdasarkan bukti yang tersedia.</P>

      <P className="text-sm text-slate-500">Catatan: kebijakan ini dapat ditinjau per kasus oleh
        dukungan dan dapat diperbarui sewaktu-waktu.</P>

      <H2>Hubungi Kami</H2>
      <P>WhatsApp Admin{" "}
        <a className="text-blue-600 hover:underline" href={waLink()} target="_blank" rel="noopener noreferrer">{BUSINESS.whatsappDisplay}</a>.</P>
    </PublicPage>
  );
}
